
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec148"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec148"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7nhm9", function(module, exports) {

$parcel$export(module.exports, "hideElement", () => $55e824ff15c161b3$export$7669482c90f5c50f);
$parcel$export(module.exports, "displayElement", () => $55e824ff15c161b3$export$1711704c205b108c);
$parcel$export(module.exports, "getLanguageAndLocation", () => $55e824ff15c161b3$export$b9768862bb795903);
$parcel$export(module.exports, "doesPhoneticAudioMatch", () => $55e824ff15c161b3$export$67bf144f1848a5f1);
$parcel$export(module.exports, "getPhonetic", () => $55e824ff15c161b3$export$95f52cb43d8d060c);
$parcel$export(module.exports, "isAudioAvailable", () => $55e824ff15c161b3$export$da90876c91f8279a);
$parcel$export(module.exports, "displayFormInputError", () => $55e824ff15c161b3$export$de1d94ae3ed136f5);
$parcel$export(module.exports, "hideFormInputError", () => $55e824ff15c161b3$export$d5ce6c99844aab8c);
$parcel$export(module.exports, "displayNotFoundDiv", () => $55e824ff15c161b3$export$5a035bb50929e57a);
$parcel$export(module.exports, "capitalizeFirstLetter", () => $55e824ff15c161b3$export$d07f57595c356899);
$parcel$export(module.exports, "updateElementColors", () => $55e824ff15c161b3$export$d2f0e44ce68e891d);
$parcel$export(module.exports, "removeClasses", () => $55e824ff15c161b3$export$33233bd73e8de239);
$parcel$export(module.exports, "changeFontFamily", () => $55e824ff15c161b3$export$67c8fd390fe3ada5);
// HELPERS
// Helpers for every file
function $55e824ff15c161b3$export$7669482c90f5c50f(element) {
    element.classList.add("hidden");
}
function $55e824ff15c161b3$export$1711704c205b108c(element) {
    element.classList.remove("hidden");
}
// Helpers for 'main.js'
function $55e824ff15c161b3$export$b9768862bb795903() {
    const preferredLanguage = navigator.language;
    const [language, location] = preferredLanguage.split("-");
    return {
        language: language,
        location: location
    };
}
function $55e824ff15c161b3$export$67bf144f1848a5f1(phonetic, language, location) {
    const languageSubstring = `/${language}/`;
    const locationSubstring = `-${location.toLowerCase()}`;
    return phonetic.audio.includes(languageSubstring) && phonetic.audio.includes(locationSubstring);
}
function $55e824ff15c161b3$export$95f52cb43d8d060c(phonetics, language, location, data) {
    const phonetic = phonetics.find((phonetic)=>$55e824ff15c161b3$export$67bf144f1848a5f1(phonetic, language, location));
    let phoneticValue = phonetic?.text || "";
    // If there is no audio value, then have the 'phoneticValue' be equal to the 'phonetic' property.
    if (phoneticValue === "" && data[0].hasOwnProperty("phonetic")) phoneticValue = data[0].phonetic;
    // If there is no audio value and there is no 'phonetic' property, have the 'phoneticValue' be equal to the 'text' property's value in the first object of the 'phonetics' array.
    if (phoneticValue === "" && !data[0].hasOwnProperty("phonetic")) phoneticValue = phonetics[0]?.text;
    return phoneticValue === undefined ? "" : phoneticValue;
}
function $55e824ff15c161b3$export$da90876c91f8279a(phonetics, language, location) {
    return phonetics.some((phonetic)=>$55e824ff15c161b3$export$67bf144f1848a5f1(phonetic, language, location));
}
function $55e824ff15c161b3$export$de1d94ae3ed136f5(spinnerElement, formInputElement, formInputErrorElement, notFoundElement) {
    $55e824ff15c161b3$export$7669482c90f5c50f(spinnerElement);
    // Remove focus from 'formInput'
    formInputElement.blur();
    // Turn the border of 'formInput' red
    formInputElement.classList.add("form__input--red");
    // Display 'form__input-error'
    $55e824ff15c161b3$export$1711704c205b108c(formInputErrorElement);
    // Hide 'notFound' div if it is currently being displayed
    $55e824ff15c161b3$export$7669482c90f5c50f(notFoundElement);
}
function $55e824ff15c161b3$export$d5ce6c99844aab8c(formInputElement, formInputErrorElement) {
    // Remove 'form__input--red' class from 'formInput' if it is present.
    formInputElement.classList.remove("form__input--red");
    // Hide 'formInputError' if it is currently being displayed.
    $55e824ff15c161b3$export$7669482c90f5c50f(formInputErrorElement);
}
function $55e824ff15c161b3$export$5a035bb50929e57a(spinnerElement, formInputElement, formInputErrorElement, resultsContainerElement, notFoundElement) {
    $55e824ff15c161b3$export$7669482c90f5c50f(spinnerElement);
    // Remove focus from 'formInput'
    formInputElement.blur();
    $55e824ff15c161b3$export$d5ce6c99844aab8c(formInputElement, formInputErrorElement);
    // If there is a definition currenty being displayed, it needs to be removed.
    resultsContainerElement.innerHTML = "";
    // Display the 'notFound' div
    $55e824ff15c161b3$export$1711704c205b108c(notFoundElement);
}
function $55e824ff15c161b3$export$d07f57595c356899(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
}
// Helpers for 'color-themes.js'
function $55e824ff15c161b3$var$toggleElementColor(elementClass, colorClass) {
    const element = document.querySelector(`.${elementClass}`);
    if (element) element.classList.toggle(colorClass);
}
function $55e824ff15c161b3$var$toggleMultipleElementsColor(elementsClass, colorClass) {
    const elements = document.querySelectorAll(`.${elementsClass}`);
    if (elements) for (let el of elements)el.classList.toggle(colorClass);
}
function $55e824ff15c161b3$var$toggleClasses(classesToToggle) {
    classesToToggle.forEach(({ element: element, className: className })=>{
        element.classList.toggle(className);
    });
}
function $55e824ff15c161b3$export$d2f0e44ce68e891d(classesToToggle) {
    // Toggle classes on/off for elements that are already in the DOM.
    $55e824ff15c161b3$var$toggleClasses(classesToToggle);
    // Toggle classes on/off for elements that are not already in the DOM.
    $55e824ff15c161b3$var$toggleElementColor("word", "dark");
    $55e824ff15c161b3$var$toggleMultipleElementsColor("part-of-speech", "dark");
    $55e824ff15c161b3$var$toggleMultipleElementsColor("horizontal-line", "horizontal-line--dark");
    $55e824ff15c161b3$var$toggleMultipleElementsColor("word-meaning", "dark");
    $55e824ff15c161b3$var$toggleElementColor("source", "source--dark");
    $55e824ff15c161b3$var$toggleElementColor("source__text", "source__text--dark");
    $55e824ff15c161b3$var$toggleElementColor("source__link", "source__link--dark");
    $55e824ff15c161b3$var$toggleMultipleElementsColor("header__font-style", "dark");
}
// Helpers for 'font-styles.js'
function $55e824ff15c161b3$export$33233bd73e8de239(element, ...classes) {
    element.classList.remove(...classes);
}
function $55e824ff15c161b3$export$67c8fd390fe3ada5(fontStyle, element) {
    if (fontStyle === "Sans Serif") element.classList.add("body--font-inter");
    else if (fontStyle === "Serif") element.classList.add("body--font-lora");
    else if (fontStyle === "Mono") element.classList.add("body--font-inconsolata");
}

});


parcelRequire("7nhm9");

//# sourceMappingURL=index.64afcd02.js.map
